import React from "react";
import { StatusToggleSwitch } from "../StatusToggleSwitch";
import { packageSubjectSessionStatus } from "../../redux/features/mastersSlice";

export const PackageSubjectSessionStatus = ({ params }) => {
    return (
        <div>
            <StatusToggleSwitch
                initialValue={params.isActive}
                api={packageSubjectSessionStatus(
                    params.packageSubjectSessionId
                )}
            />
        </div>
    );
};
